
import lazyLoading from '../../utils/index'
import { SET_MENU } from './../mutations-type'
const menu = {
    state: {
        menuTree: [],
    },
    mutations: {
        [SET_MENU]: (state, menuItems) => {
            if (!menuItems.length) {
                state.menu = [];
                return
            }
            let stro = menuItems;
            stro.forEach(i => {
                // i.component = lazyLoading(i.component);
                if(  i.children.length === 0){
                    i.children.push({path:i.path,component:i.component,icon:i.icon,name:i.name,})
                    // i.component = 'layout/layout'
                    i.component = 'layout/layout';
                    i.path = '/',
                    i.isOnly = true
                }
            })
            // 后台传来的menu参数是字符串 所以要把component处理一下
            stro.forEach(i => {
                i.component = lazyLoading(i.component);
                i.children.forEach((child) => {
                    child.component = lazyLoading(child.component)
                })
            })
            state.menuTree = stro;
        },
    }
}

export default menu